





















import Vue from 'vue'
import StoreController from '@/calendesk/controllers/StoreController'

export default Vue.extend({
  name: 'CCalendarSearchPreview',
  props: {
    classForViewRound: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDarkMode (): boolean {
      return StoreController.isDarkMode()
    }
  }
})
